import React from "react";

import { faBars } from "@fortawesome/pro-solid-svg-icons/faBars";
import { faChartLine } from "@fortawesome/pro-solid-svg-icons/faChartLine";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Radio from "antd/es/radio";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import RadioGroup from "@app/component/input/RadioGroup";

import ViewMode, { getViewModeDisplayName } from "../../enum/ViewMode";

interface Props {
  onChange: (value: ViewMode) => void;
  value: ViewMode;
}

const ViewModeSelector: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();
  return (
    <RadioGroup<ViewMode> buttonStyle="solid" onChange={onChange} value={value}>
      <Tooltip placement="top" title={getViewModeDisplayName(intl, ViewMode.KANBAN)}>
        <Radio.Button key={ViewMode.KANBAN} value={ViewMode.KANBAN}>
          <svg
            className="svg-inline--fa"
            height="1em"
            viewBox="0 0 598 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M518.588 0H53.647C24.018 0 0 24.56 0 54.857v402.286C0 487.441 24.018 512 53.647 512h182.735c46.903 0 85.014-37.854 85.331-84.757l.17-24.957h196.705c29.627 0 53.649-6.274 53.649-36.572V54.857C572.237 24.56 548.215 0 518.587 0zM250.353 438.857H71.53V82.286h178.824v356.57zm249.61-100.571H321.14l.742-256h178.082v256z"
              fill="currentColor"
            />
          </svg>
        </Radio.Button>
      </Tooltip>
      <Tooltip placement="top" title={getViewModeDisplayName(intl, ViewMode.LIST)}>
        <Radio.Button key={ViewMode.LIST} value={ViewMode.LIST}>
          <FontAwesomeIcon icon={faBars} size="sm" />
        </Radio.Button>
      </Tooltip>
      <Tooltip placement="top" title={getViewModeDisplayName(intl, ViewMode.FORECAST)}>
        <Radio.Button key={ViewMode.FORECAST} value={ViewMode.FORECAST}>
          <FontAwesomeIcon icon={faChartLine} size="sm" />
        </Radio.Button>
      </Tooltip>
    </RadioGroup>
  );
};

export default ViewModeSelector;
